<div id="particles-js-home"></div>
<div class="content">
  <h1>Henock Belay</h1>
  <h2>Computer Engineer | Full Stack Developer </h2>
  <p>Sunnyvale, CA</p>
  <h3>About Me</h3>
  <p>A passionate Computer Engineer with expertise in full stack web development, specializing in Angular, Java, and
    Spring Boot. Dedicated to building innovative solutions that drive business success.</p>
</div>